import {
  Waves,
  Sailboat,
  Anchor,
  TreePine,
  Slice,
  Volleyball,
  Flame,
  Tent,
  Fish,
} from "lucide-react";
import swimmingAsset from "@/assets/activity-swimming.png.asset.json";
import ropeSwingAsset from "@/assets/activity-rope-swing.jpg.asset.json";
import kayakingImg from "@/assets/kayaking.jpg";
import paddleboardingImg from "@/assets/paddleboarding-swimming.jpg";
import frogSlideImg from "@/assets/feature-waterslide.jpg";
import volleyballImg from "@/assets/beach-volleyball.png";
import fishingBoyAsset from "@/assets/activity-fishing-boy.jpg.asset.json";
import bbqImg from "@/assets/bbq-grilling.jpg";
import hammockImg from "@/assets/hammock-relaxing.jpg";

const activities = [
  { icon: Waves, label: "Swimming", image: swimmingAsset.url },
  { icon: Sailboat, label: "Kayaking", image: kayakingImg },
  { icon: Anchor, label: "Paddleboarding", image: paddleboardingImg },
  { icon: TreePine, label: "Rope Swing", image: ropeSwingAsset.url },
  { icon: Slice, label: "Frog Slide", image: frogSlideImg },
  { icon: Volleyball, label: "Sand Volleyball", image: volleyballImg },
  { icon: Fish, label: "Fishing", image: fishingBoyAsset.url },
  { icon: Flame, label: "BBQ Grills", image: bbqImg },
  { icon: Tent, label: "Hammocks", image: hammockImg },
];

const ActivitiesIconGrid = () => {
  return (
    <section
      id="activities"
      style={{ scrollMarginTop: "96px" }}
      className="scroll-mt-24 py-16 md:py-20"
    >
      <div className="container mx-auto px-4">
        <div className="text-center mb-10">
          <h2 className="font-serif text-3xl md:text-4xl text-foreground mb-3">Activities</h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {activities.map(({ icon: Icon, label, image }) => (
            <div
              key={label}
              className="group relative aspect-[4/5] overflow-hidden rounded-xl border border-border bg-card hover:border-primary transition-colors"
            >
              <img
                src={image}
                alt={label}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
              <div className="absolute bottom-3 right-3 flex h-10 w-10 items-center justify-center rounded-full bg-background/90 shadow-soft">
                <Icon className="h-5 w-5 text-primary" aria-hidden="true" />
              </div>
              <div className="absolute bottom-3 left-3 right-16">
                <span className="font-serif text-base md:text-lg text-white drop-shadow-md">
                  {label}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ActivitiesIconGrid;